export const RED_TESTING_CONFIG = {
  experiments: [
    {
      id: 'influencers-typeTraining',
      variants: [
        {
          weight: 0.25
        },
        {
          weight: 0.25
        },
        {
          weight: 0.25
        }
      ]
    },
    {
      id: 'redirect-lapa-checkout',
      variants: [
        {
          weight: 0.1
        }
      ]
    }
  ]
}
